/**
 * @generated SignedSource<<09add80ff9dd6de5a0538ff539d19a5b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VideoElementSourceTypeV2 = "s3" | "vimeo";
import { FragmentRefs } from "relay-runtime";
export type videoElementForm_VideoElementFragment$data = {
  readonly availableSourceTypes: ReadonlyArray<VideoElementSourceTypeV2>;
  readonly id: string;
  readonly title: string;
  readonly videoSource: {
    readonly folder?: string;
    readonly sourceType: VideoElementSourceTypeV2;
    readonly vimeoId?: string;
    readonly vimeoVideoSource?: {
      readonly id: string;
    } | null;
  };
  readonly " $fragmentType": "videoElementForm_VideoElementFragment";
};
export type videoElementForm_VideoElementFragment$key = {
  readonly " $data"?: videoElementForm_VideoElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"videoElementForm_VideoElementFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "videoElementForm_VideoElementFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availableSourceTypes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "videoSource",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceType",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vimeoId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vimeo_VimeoVideoSource",
              "kind": "LinkedField",
              "name": "vimeoVideoSource",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "VimeoVideoElementSourceV2",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "folder",
              "storageKey": null
            }
          ],
          "type": "S3VideoElementSourceV2",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "VideoElement",
  "abstractKey": null
};
})();

(node as any).hash = "2b7bc5dddb32363719fc65f48d6ecb80";

export default node;
